// hooks/useAuthData.ts
import { useSession } from "next-auth/react";

export const useAuthData = () => {
  const { data: session, status } = useSession();

  return {
    user: session?.user,
    nom: session?.user?.nom,
    prenom: session?.user?.prenom,
    titre: session?.user?.titre,
    isLoading: status === "loading",
    isAuthenticated: status === "authenticated",
  };
};